(function () {
  var CFG = window.__NLRECS__ || {};
  var ENDPOINT = CFG.endpoint;
  var SESSION_TTL = 30 * 60 * 1000;   // a rolling half hour, as search uses
  var IMPRESSION_MS = 1000;           // seen, not merely scrolled past
  var ROOT = CFG.root || '/';
  if (ROOT.charAt(ROOT.length - 1) !== '/') ROOT += '/';

  // Human names for the four rails, so GA4's Item List reports read as
  // English rather than as slugs. Keys must match `data-recs-rail`.
  var LIST_NAMES = {
    outfit: 'PDP — Complete the outfit',
    similar: 'PDP — More like this',
    cart: 'Cart drawer — Goes with your order',
    bestsellers: 'Bestsellers'
  };

  var impressions = [], clicks = [], adds = [], lastAttr = '';

  function allowed() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      return !!(cp && cp.analyticsProcessingAllowed && cp.analyticsProcessingAllowed());
    } catch (e) { return false; }
  }

  // localStorage, not sessionStorage: a shopper meets a rail on a PDP and
  // buys two pages later, sometimes in a tab opened from it. A session that
  // does not survive that hop attributes the order to nobody.
  function session() {
    if (!allowed()) return null;
    var now = Date.now(), s = null;
    try { s = JSON.parse(localStorage.getItem('nlr_session') || 'null'); } catch (e) {}
    if (s && s.id && now - s.ts < SESSION_TTL) {
      s.ts = now;
    } else {
      var p = new URLSearchParams(location.search);
      s = {
        id: 'nlr-' + now.toString(36) + '-' + Math.random().toString(36).slice(2, 10),
        ts: now,
        referrer: document.referrer || null,
        landingPath: location.pathname || null,
        utmSource: p.get('utm_source'),
        utmMedium: p.get('utm_medium'),
        utmCampaign: p.get('utm_campaign')
      };
    }
    try { localStorage.setItem('nlr_session', JSON.stringify(s)); } catch (e) {}
    return s;
  }

  function device() {
    return window.matchMedia && window.matchMedia('(max-width: 1023px)').matches
      ? 'mobile' : 'desktop';
  }

  /**
   * GA4 mirror.
   *
   * `view_item_list` and `select_item` are the standard names on purpose —
   * they light up GA4's built-in Item List reports with no configuration,
   * and neither sits on the purchase funnel, so nothing can be
   * double-counted by sending them.
   *
   * The add is deliberately NOT `add_to_cart`. That name IS on the funnel,
   * and Shopify's own GA4 integration already fires it; sending a second
   * one would inflate the store's cart-addition count. A custom name keeps
   * the rail's contribution measurable without corrupting the standard
   * report.
   */
  function dl(event, listId, items) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: event,
        item_list_id: 'recs_' + listId,
        item_list_name: LIST_NAMES[listId] || listId,
        items: items.map(function (it) {
          return {
            item_id: it.productId,
            item_name: it.handle || undefined,
            index: it.position
          };
        })
      });
    } catch (e) { /* analytics must never break the page */ }
  }

  function flush() {
    if (!impressions.length && !clicks.length && !adds.length) return;
    var payload = {
      consent: allowed(),
      impressions: impressions, clicks: clicks, adds: adds
    };
    impressions = []; clicks = []; adds = [];
    try {
      // text/plain keeps this a CORS "simple request". A JSON content-type
      // triggers a preflight that sendBeacon cannot answer, which would drop
      // precisely the batch sent as the page unloads.
      var blob = new Blob([JSON.stringify(payload)], { type: 'text/plain;charset=UTF-8' });
      if (!navigator.sendBeacon || !navigator.sendBeacon(ENDPOINT, blob)) {
        fetch(ENDPOINT, {
          method: 'POST', mode: 'cors', keepalive: true,
          headers: { 'Content-Type': 'text/plain' },
          body: JSON.stringify(payload)
        }).catch(function () {});
      }
    } catch (e) {}
  }

  /**
   * Attribution. Cart attributes ride the whole checkout and arrive on the
   * order as note_attributes — the only channel connecting a rail to
   * revenue, with no pixel, ad blocker or consent banner in between.
   *
   * Written on click rather than on add-to-cart, exactly as search does it,
   * so no cart code has to change: the attributes are harmless on a cart
   * nobody buys, and last-touch is the intended reading. The underscore
   * prefix keeps them off the confirmation email and the packing slip.
   */
  function cartAttrs(sid, listId, productId) {
    var key = sid + '|' + listId + '|' + productId;
    if (key === lastAttr) return;
    lastAttr = key;
    fetch(ROOT + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: { _nlr_sid: sid, _nlr_list: listId, _nlr_pid: String(productId) }
      })
    }).catch(function () {});
  }

  /**
   * The ordered products a rail is showing, straight off the wrapper.
   *
   * Read from `data-recs-items` rather than counted out of the DOM because
   * Liquid already knows the answer exactly, and the DOM does not: the cart
   * rail's cards carry no product id of their own, and the sliders wrap
   * their slides in markup that is free to change.
   */
  function itemsOf(rail) {
    var raw = rail.getAttribute('data-recs-items') || '';
    var out = [];
    raw.split(',').forEach(function (pair) {
      var i = pair.indexOf(':');
      if (i < 1) return;
      out.push({
        productId: pair.slice(0, i),
        handle: pair.slice(i + 1) || null,
        position: out.length + 1
      });
    });
    return out;
  }

  /** Which product a click landed on, whichever card shape the rail uses. */
  function hitProductId(target, rail) {
    var card = target.closest('[data-product-item]');
    if (card && rail.contains(card)) {
      var id = card.getAttribute('data-product-id');
      if (id) return id;
    }
    // Cart drawer cards are quick-add tiles keyed `upsell-<id>`.
    var tile = target.closest('[data-quick-add-product]');
    if (tile && rail.contains(tile)) {
      var key = tile.getAttribute('data-key') || '';
      if (key.indexOf('upsell-') === 0) return key.slice(7);
    }
    return null;
  }

  function record(rail, productId, kind) {
    var listId = rail.getAttribute('data-recs-rail');
    var items = itemsOf(rail);
    var hit = null;
    for (var i = 0; i < items.length; i++) {
      if (items[i].productId === productId) { hit = items[i]; break; }
    }
    if (!hit) return;
    var s = session();
    var row = {
      sessionId: s && s.id,
      list: listId,
      sourceProductId: rail.getAttribute('data-recs-source') || null,
      productId: hit.productId,
      handle: hit.handle,
      position: hit.position,
      device: device()
    };
    if (kind === 'add') {
      adds.push(row);
      dl('recs_add_to_cart', listId, [hit]);
    } else {
      clicks.push(row);
      dl('select_item', listId, [hit]);
      if (s) cartAttrs(s.id, listId, hit.productId);
    }
    flush();
  }

  // ── Impressions ────────────────────────────────────────────────────────
  // A rail counts as seen when half of it has been on screen for a second.
  // Anything looser counts rails the shopper scrolled straight past, which
  // would deflate every click-through rate the engine is tuned on.
  //
  // Keyed on what a rail showed, not on the element that showed it. The
  // cart drawer re-renders its whole section on every cart change, so its
  // rail is a new element each time and a WeakSet keyed on the element
  // treated every quantity tweak as a rail the shopper had never seen. One
  // shopper nudging a quantity four times booked five full sets of slot
  // impressions for the same six products, which inflates the cart rail's
  // denominator and understates the only CTR it can produce.
  //
  // The signature is the rail plus its ordered contents, so a genuine
  // change — the cart rail recommending different products after the cart
  // changes — still counts as the new impression it is. The PDP and
  // bestsellers rails never re-render, so nothing about them changes.
  var seen = {};
  function railSignature(rail) {
    var items = itemsOf(rail);
    if (!items.length) return null;
    return rail.getAttribute('data-recs-rail') + '|' + items.map(function (it) {
      return it.productId + ':' + it.position;
    }).join(',');
  }
  var io = null;
  if (window.IntersectionObserver) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var rail = entry.target;
        if (!entry.isIntersecting) {
          if (rail.__nlrTimer) { clearTimeout(rail.__nlrTimer); rail.__nlrTimer = null; }
          return;
        }
        if (rail.__nlrTimer) return;
        var pending = railSignature(rail);
        if (!pending || seen[pending]) return;
        rail.__nlrTimer = setTimeout(function () {
          rail.__nlrTimer = null;
          // Re-read: the cart can change again inside the dwell second, and
          // what is on screen now is what was actually seen.
          var sig = railSignature(rail);
          if (!sig || seen[sig]) return;
          // A folded cart rail is still in the layout (its height animates to
          // zero) but visibility:hidden, and the observer cannot tell.
          if (getComputedStyle(rail).visibility === 'hidden') return;
          seen[sig] = 1;
          var listId = rail.getAttribute('data-recs-rail');
          var items = itemsOf(rail);
          if (!items.length) return;
          var s = session();
          impressions.push({
            sessionId: s && s.id,
            list: listId,
            sourceProductId: rail.getAttribute('data-recs-source') || null,
            device: device(),
            items: items.map(function (it) {
              return { productId: it.productId, position: it.position };
            })
          });
          dl('view_item_list', listId, items);
        }, IMPRESSION_MS);
      });
    }, { threshold: 0.5 });
  }

  function scan() {
    var rails = document.querySelectorAll('[data-recs-rail]');
    for (var i = 0; i < rails.length; i++) {
      var rail = rails[i];
      if (rail.__nlrBound) continue;
      rail.__nlrBound = true;

      if (io) io.observe(rail);

      (function (rail) {
        rail.addEventListener('click', function (ev) {
          // Guarded because a click can land on a node with no `closest` —
          // a text node under some engines, or the document itself.
          var t = ev.target;
          if (!t || typeof t.closest !== 'function') return;
          var pid = hitProductId(t, rail);
          if (!pid) return;
          // The quick-add button is an add, not a navigation. Everything
          // else in a card is a link to the PDP.
          var isAdd = !!t.closest('[data-submit]');
          record(rail, pid, isAdd ? 'add' : 'click');
        }, true);
      })(rail);
    }
  }

  // The cart drawer re-renders its whole section on every cart change, so
  // its rail is a different element each time and has to be re-bound.
  // Debounced because a cart update fires several mutations in a row.
  var rescan = null;
  if (window.MutationObserver) {
    new MutationObserver(function () {
      clearTimeout(rescan);
      rescan = setTimeout(scan, 200);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  // A shopper who sees a rail and then leaves is the most interesting one in
  // the set, so the buffer has to survive the tab going away.
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') flush();
  });
  window.addEventListener('pagehide', flush);
})();
